import * as wjGrid from "@grapecity/wijmo.grid"
import { TWijmoListBox } from "../../type/wijmoComponents"

/**
 * FlexGrid.ColumnLayout用インタフェース
 */
export type TFlexGridColumnLayout = {
  columns: wjGrid.ColumnCollection
}
/**
 * グリッド自体の初期化時用のレイアウト復元メソッド
 * @param grid 対象のFlexGrid
 * @param thisPageLayoutKey グリッド保持用LocalStorageKey
 */
export const gridInitializedRestoreLayout = async (
  grid: wjGrid.FlexGrid,
  thisPageLayoutKey: string
) => {
  // グリッドの前回の表示を再現
  if (
    localStorage.getItem(thisPageLayoutKey) &&
    localStorage.getItem(thisPageLayoutKey) !== undefined &&
    localStorage.getItem(thisPageLayoutKey) !== ""
  ) {
    // 保存されたレイアウト定義をインタフェースに沿ってデシリアライズ
    const レイアウト = localStorage.getItem(thisPageLayoutKey) as string
    await applyGridLayout(grid, レイアウト)
  }
}

/**
 * FlexGridへのColumnLayout適用処理
 * @param grid FlexGrid
 * @param newColumnLayoutJson 新しいColumnLayoutのJson
 */
export const applyGridLayout = (
  grid: wjGrid.FlexGrid,
  newColumnLayoutJson: string,
  columnPicker?: TWijmoListBox
) => {
  return new Promise<void>((resolve, reject) => {
    try {
      let newColumnLayout: TFlexGridColumnLayout =
        JSON.parse(newColumnLayoutJson)

      if (newColumnLayout.columns) {
        // wijmoコントロールの描画停止
        grid.beginUpdate()
        columnPicker?.beginUpdate()

        const sortedGridCols = new Array<wjGrid.Column>()

        // 新しいColumnLayoutを元に設定の反映を実施
        newColumnLayout.columns.forEach((column, columnLayoutIndex) => {
          // ヘッダ名およびバインド情報が一致するカラムを対象とする
          // ボタン列などはバインドが無いため、その場合はヘッダ名一致かつバインドが両者未定義で一致とする
          let foundGridCol = grid.columns.find(
            (gridCol) =>
              gridCol.header === column.header &&
              ((!column.aggregate && !gridCol.aggregate) ||
                (column.aggregate && column.aggregate === gridCol.aggregate)) &&
              ((!column.binding && !gridCol.binding) ||
                (column.binding && column.binding === gridCol.binding))
          )

          if (foundGridCol) {
            // 並び替え用に配列に順次追加
            sortedGridCols.push(foundGridCol)

            // visibleを再現
            // columnPickerがいる場合はcolumnPicker越しにvisibleを操作する
            const visible = column.visible === undefined || column.visible
            if (columnPicker) {
              columnPicker.setItemChecked(columnLayoutIndex, visible)
            } else {
              if (column.visible !== undefined)
                foundGridCol.visible = column.visible
            }

            // widthを再現
            if (column.width !== undefined) foundGridCol.width = column.width
          }
        })

        // 並び替え
        sortedGridCols.forEach((gridColumn, newIndex) => {
          grid.columns.remove(gridColumn)
          grid.columns.insert(newIndex, gridColumn)
        })

        // wijmoコントロールの描画再開
        grid.endUpdate()
        columnPicker?.endUpdate()
      }

      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

const flexGridHelper = {
  gridInitializedRestoreLayout,
  applyGridLayout,
}
export default flexGridHelper
